<template>
    <div>

        <h1 class="mt-4">Registrera behandlingar på arbetsplatsen</h1>

        <div class="content-container mb-8">

            <div class="row mb-8">
                <div class="col-24 col-sm-14 col-lg-9 col-xl-6 d-flex">

                    <!-- <button class="btn btn-light me-3" @click="changeDate('previous')"><</button> -->
                    <datepicker-new
                        input-class="form-control"
                        placeholder="Välj"
                        :language="former.datepicker.locale"
                        :use-utc="true"
                        :monday-first="true"
                        :format="formerDateFormat"
                        v-model="date_from"
                    />

                    <div class="p-2">till</div>

                    <datepicker-new
                        input-class="form-control"
                        placeholder="Välj"
                        :language="former.datepicker.locale"
                        :use-utc="true"
                        :monday-first="true"
                        :format="formerDateFormat"
                        v-model="date_to"
                    />
                    <!-- <button class="btn btn-light ms-3" @click="changeDate('next')">></button> -->

                </div>

                <div class="col-24 col-sm-1 col-lg-1"></div>

                <div class="col-24 col-sm-7 col-lg-6">
                    <input-select
                        formGroupClass="mb-0"
                        name="admin_id_contact_filter"
                        v-model="admin_id_contact_filter"
                        :options="adminOptions"
                    />
                </div>

            </div>

            <div class="list-loader-outer">
                <transition name="fade" mode="out-in">
                    <div class="list-loader" v-if="fetcher.loading || save_loading">
                        <div class="spinner-border" role="status"></div>
                    </div>
                </transition>
            </div>

            <transition name="fade" mode="out-in">
                <div>
                <div :key="'r'+index" v-for="(row, index) in rows">

                    <div v-if="admin_id_contact_filter == null || admin_id_contact_filter == row.company.admin_id_contact_1 || admin_id_contact_filter == row.company.admin_id_contact_2">

                        <h2 class="mb-6">{{ row.company.name }}</h2>

                        <div class="mb-6" :key="'r'+index+'+w'+treatments_by_workplace.workplace.id" v-for="treatments_by_workplace in row.treatments_by_workplace">
                            <h3 class="mb-6">{{ treatments_by_workplace.workplace.title }}</h3>

                            <div class="mb-4" :key="'r'+index+'+w'+treatments_by_workplace.workplace.id+'d'+treatments_by_day.day" v-for="treatments_by_day in treatments_by_workplace.treatments_by_day">

                                <h4>{{ treatments_by_day.day }}</h4>

                                <div class="new-list-group">

                                    <div class="new-list-group-item mb-1"
                                         :key="'t'+treatment.id"
                                         :class="{ 'timezynk-saved' : treatment.admin_id, 'timezynk-error' : treatment.employee_error }"
                                         style="font-weight: 400;" v-for="(treatment, index) in treatments_by_day.treatments">
                                        <div class="row">
                                            <div class="col-24 col-md-2" style="min-height: 36px;">
                                                Kl {{ treatment.treatment_at_time }}
                                            </div>
                                            <div class="col-24 col-md-6 d-flex">
                                                {{ getClinicNamePerson(treatment.clinic_id) }}
                                            </div>
                                            <div class="col-24 col-md-4 d-flex">
                                                <div class="form-check">
                                                    <input class="form-check-input" :id="'notreatment'+treatment.id" type="checkbox" v-model="treatment.timezynk_no_show">
                                                    <label :for="'notreatment'+treatment.id" class="form-check-label">Ingen bokning</label>
                                                </div>
                                            </div>
                                            <div class="col-24 col-md-6 d-flex" :class="{ 'is-invalid' : treatment.employee_error }" v-if="!treatment.timezynk_no_show">
                                                <v-select
                                                    label="name"
                                                    placeholder="Välj anställd"
                                                    :options="row.company.employees"
                                                    :reduce="employees => employees.id"
                                                    v-model="treatment.employee_id"
                                                />
                                            </div>
                                            <div class="col-24 col-md-6 d-flex justify-content-end">

                                                <div class="row" v-if="!treatment.timezynk_no_show && row.company.employee_part_payment_type === 'allowance_or_salary'">

                                                    <div class="col-8">Delbetalning:</div>

                                                    <div class="col-8 pt-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="radio" value="allowance" v-model="treatment.employee_part_payment_type">
                                                            <label class="form-check-label" :for="'customer-payment-wellness'+index">Friskvård</label>
                                                        </div>
                                                    </div>

                                                    <div class="col-8 pt-1">
                                                        <div class="form-check">
                                                            <input class="form-check-input" type="radio" value="salary" v-model="treatment.employee_part_payment_type">
                                                            <label class="form-check-label" :for="'customer-payment-salary'+index">Lön</label>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>

                                        </div>

                                    </div>

                                </div>

                                <div class="d-flex justify-content-end">
                                    <button class="btn btn-primary" @click="save(treatments_by_day.treatments, row.company.employee_part_payment_type)">
                                        <span class="spinner-border spinner-border-sm"></span>
                                        Spara
                                    </button>
                                    <!-- om en sparning redan gjorts. fram till datum x då det låses (samma logik som för mottagningsbehandlingar) -->
                                    <!-- <button class="btn btn-primary" v-if="saved" @click="saveSlots()">
                                        <span class="spinner-border spinner-border-sm"></span>
                                        Spara ändringar
                                    </button> -->
                                </div>

                            </div>

                        </div>

                    </div>

                </div>
                </div>
            </transition>

            <div>

                <transition name="fade" mode="out-in">
                    <div class="w-100 text-center" style="padding-top:210px; font-size: 24px; color:#aaa;" v-if="rows.length === 0 && !fetcher.loading">
                        Inga synkroniserade behandlingar finns på detta datum.
                    </div>
                </transition>

            </div>

        </div>

    </div>
    </template>

<script>
import fetcher from '../../../../shared/mixins/fetcher'
import vSelect from 'vue-select'
import axios from 'axios'
import moment from 'moment'
import uniqid from 'uniqid'

export default {

    mixins: [
        fetcher
    ],

    components: {
        vSelect
    },

    data () {
        return {
            employee_id: null,
            clinic_id: null,
            date_from: moment().toDate(),
            date_to: moment().toDate(),
            admin_id_contact_filter: null,
            save_loading: false,

            clinics: [],
            rows: [],
            admins: [],

            fetcher: {
                autoFill: [
                    'clinics',
                    'rows',
                    'admins'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/timezynk-treatments/fetch?date_from=' + moment(this.date_from).format('YYYY-MM-DD') + '&date_to=' + moment(this.date_to).format('YYYY-MM-DD')
        },
        adminOptions () {
            const options = [{ value: null, label: 'Kontaktperson' }]
            this.admins.forEach(a => {
                options.push({ value: a.id, label: a.name })
            })
            return options
        }
    },

    watch: {
        date_from () {
            this.fetcherFetch()
        },
        date_to () {
            this.fetcherFetch()
        }
    },

    methods: {
        updateClinics (treatments_by_workplace) {
            console.log('updateClinics')
            console.log(treatments_by_workplace)

            treatments_by_workplace.treatments.forEach(treatment => {
                treatment.clinic_id = treatments_by_workplace.mass_assign_clinic_id
            })
        },

        save (treatments, company_part_payment_type) {
            console.log('save treatments, company_part_payment_type = ' + company_part_payment_type)
            console.log(treatments)

            this.save_loading = true

            const treatments_to_patch = []

            treatments.forEach(treatment => {
                this.$set(treatment, 'employee_error', false)

                if (treatment.timezynk_no_show) {
                    treatment.employee_id = null
                }

                if (!treatment.timezynk_no_show && !treatment.employee_id) {
                    this.$set(treatment, 'employee_error', true)
                }

                if (!treatment.timezynk_no_show && company_part_payment_type === 'allowance_or_salary' && (treatment.employee_part_payment_type !== 'allowance' && treatment.employee_part_payment_type !== 'salary')) {
                    this.$set(treatment, 'employee_error', true)
                }

                if (!treatment.employee_error) {
                    treatment.admin_id = uniqid()
                    treatments_to_patch.push(treatment)
                }
            })

            axios.patch('/timezynk-treatments/patch', {
                treatments: treatments_to_patch
            }).then(response => {
                console.log('patch response')
                console.log(response.data)

                bus.$emit(
                    'notify',
                    treatments_to_patch.length + ' behandling(ar) sparade.'
                )
                this.save_loading = false
            }).catch(error => {
                console.log('patch error')
                console.log(error.response)
                this.save_loading = false
            })
        },

        saveSlots () {
            let count = 0

            this.fake_time_slots.forEach(time_slot => {
                time_slot.clinic_error = time_slot.clinic_id == null

                if (time_slot.noshow == false) {
                    time_slot.employee_error = time_slot.employee_id == null
                } else {
                    time_slot.employee_error = false
                }

                time_slot.hasError = false
                if (time_slot.clinic_error == true || time_slot.employee_error == true) {
                    time_slot.hasError = true
                }

                time_slot.isSaved = false
                if (time_slot.hasError == false) {
                    time_slot.isSaved = true
                    count++
                }
            })

            if (count > 0) {
                bus.$emit(
                    'notify',
                    count + ' behandling(ar) sparade.'
                )
            }
        },
        /*
        changeDate (to) {
            if (to === 'next') {
                this.date = moment(this.date).add(1, 'days').toDate()
            } else {
                this.date = moment(this.date).subtract(1, 'days').toDate()
            }
        },
        */

        getClinicNamePerson (id) {
            return this.clinics.find((item) => item.clinic_id == id).name_person
        }

    }
}
</script>
